/* ============================================================
   HALFAGE — theme behaviour
   Vanilla, no dependencies. Everything degrades without JS.
   ============================================================ */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function money(cents) {
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var x = parts[0];
    var last3 = x.slice(-3);
    var rest = x.slice(0, -3);
    if (rest) last3 = ',' + last3;
    rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
    var frac = parts[1] === '00' ? '' : '.' + parts[1];
    return 'Rs. ' + rest + last3 + frac;
  }
  window.HALFAGE = window.HALFAGE || {};
  window.HALFAGE.money = money;

  /* ---------- toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2400);
  }
  window.HALFAGE.toast = toast;

  /* ---------- scroll lock ---------- */
  var lockY = 0;
  function lock() { lockY = window.scrollY; document.body.classList.add('is-locked'); document.body.style.top = -lockY + 'px'; document.body.style.position = 'fixed'; document.body.style.width = '100%'; }
  function unlock() { document.body.classList.remove('is-locked'); document.body.style.position = ''; document.body.style.top = ''; document.body.style.width = ''; window.scrollTo(0, lockY); }

  /* ---------- drawers ---------- */
  var scrim = $('[data-scrim]');
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    lock();
    var f = d.querySelector('a,button,input');
    if (f) setTimeout(function () { f.focus(); }, 320);
  }
  function closeDrawers() {
    $$('.drawer.is-open, .sheet.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    if (scrim) scrim.classList.remove('is-open');
    unlock();
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) { e.preventDefault(); openDrawer(open.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.hasAttribute('data-scrim') || e.target.classList.contains('sheet')) closeDrawers();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawers(); closeModal(); }
  });

  /* ---------- modal (size chart) ---------- */
  function closeModal() {
    $$('.modal.is-open').forEach(function (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); });
    if (!$('.drawer.is-open')) unlock();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-modal-open]');
    if (o) {
      e.preventDefault();
      var m = document.getElementById(o.getAttribute('data-modal-open'));
      if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); lock(); }
      return;
    }
    if (e.target.closest('[data-modal-close]') || e.target.classList.contains('modal')) closeModal();
  });

  /* ---------- sticky header: hide on scroll down ---------- */
  var header = $('[data-header]');
  if (header) {
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 8);
      if (header.classList.contains('header--autohide') &&
          y > 220 && y > last && !$('.drawer.is-open, .sheet.is-open')) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
      last = y;
    }, { passive: true });
  }

  /* ---------- scroll reveal ---------- */
  var targets = $$('.reveal');
  if (targets.length) {
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach(function (t) { t.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      targets.forEach(function (t) { io.observe(t); });
    }
  }

  /* ---------- accordions ---------- */
  $$('[data-acc]').forEach(function (acc) {
    var head = $('.acc__head', acc);
    var body = $('.acc__body', acc);
    if (!head || !body) return;
    if (acc.classList.contains('is-open')) body.style.height = 'auto';
    head.addEventListener('click', function () {
      var open = acc.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        body.style.height = body.firstElementChild.offsetHeight + 'px';
        setTimeout(function () { if (acc.classList.contains('is-open')) body.style.height = 'auto'; }, 420);
      } else {
        body.style.height = body.firstElementChild.offsetHeight + 'px';
        requestAnimationFrame(function () { requestAnimationFrame(function () { body.style.height = '0px'; }); });
      }
    });
  });

  /* ---------- gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var stage = $('.gallery__stage', g);
    var thumbs = $$('.gallery__thumb', g);
    var dots = $$('.gallery__dot', g);
    var slides = $$('.gallery__slide', g);

    function activate(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      if (window.innerWidth >= 990) {
        slides.forEach(function (s, n) { s.style.display = n === i ? '' : 'none'; });
      }
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        activate(i);
        if (window.innerWidth < 990 && stage) stage.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      });
      t.addEventListener('mouseenter', function () { if (window.innerWidth >= 990) activate(i); });
    });
    if (stage) {
      var tick;
      stage.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () {
          var i = Math.round(stage.scrollLeft / stage.offsetWidth);
          activate(Math.max(0, Math.min(i, slides.length - 1)));
        }, 90);
      }, { passive: true });
    }
    activate(0);
  });

  /* ---------- size selector ---------- */
  $$('[data-variants]').forEach(function (form) {
    var swatches = $$('.swatch', form);
    var label = $('[data-size-label]', form);
    var idInput = $('[name="id"]', form);
    var addBtn = $('[data-add]', form);
    swatches.forEach(function (s) {
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (s.classList.contains('is-soldout')) return;
        swatches.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        s.classList.add('is-active');
        s.setAttribute('aria-checked', 'true');
        if (label) label.textContent = s.dataset.size;
        if (idInput && s.dataset.variantId) idInput.value = s.dataset.variantId;
        if (addBtn) { addBtn.removeAttribute('aria-disabled'); }
        form.dataset.chosen = 'true';
      });
    });
  });

  /* ---------- quantity ---------- */
  $$('[data-qty]').forEach(function (box) {
    var out = $('[data-qty-value]', box);
    var input = $('input[name="quantity"]', box) || $('[data-qty-input]', box);
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty-step]');
      if (!b) return;
      e.preventDefault();
      var cur = parseInt((input && input.value) || (out && out.textContent) || '1', 10);
      var next = Math.max(1, Math.min(10, cur + parseInt(b.dataset.qtyStep, 10)));
      if (out) out.textContent = next;
      if (input) { input.value = next; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });


  /* ---------- collection: grid density ---------- */
  $$('[data-dens]').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('[data-dens]').forEach(function (x) { x.classList.remove('is-on'); });
      b.classList.add('is-on');
      var grid = $('[data-grid]');
      if (grid) grid.classList.toggle('is-2', b.dataset.dens === '2');
      try { document.cookie = 'halfage_dens=' + b.dataset.dens + ';path=/;max-age=2592000'; } catch (e) {}
    });
  });
  (function () {
    var m = document.cookie.match(/halfage_dens=(\d)/);
    if (m && m[1] === '2') {
      var b = $('[data-dens="2"]');
      if (b) b.click();
    }
  })();

  /* ---------- collection: auto-submit filters on desktop ---------- */
  var ffm = $('#filter-form');
  if (ffm) {
    ffm.addEventListener('change', function (e) {
      if (window.innerWidth >= 1000 && e.target.type !== 'number') ffm.submit();
    });
  }

  /* ---------- PDP: dense gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var stage = $('.gal__stage', g);
    var thumbs = $$('.gal__thumb', g);
    var dots = $$('.gal__dot', g);
    var slides = $$('.gal__slide', g);
    function set(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      if (window.innerWidth >= 1000 && thumbs.length) slides.forEach(function (s, n) { s.style.display = n === i ? '' : 'none'; });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        set(i);
        if (window.innerWidth < 1000 && stage) stage.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      });
      t.addEventListener('mouseenter', function () { if (window.innerWidth >= 1000) set(i); });
    });
    if (stage) {
      var tk;
      stage.addEventListener('scroll', function () {
        clearTimeout(tk);
        tk = setTimeout(function () { set(Math.round(stage.scrollLeft / stage.offsetWidth)); }, 80);
      }, { passive: true });
    }
    set(0);
  });

  /* ---------- PDP: inline size row ---------- */
  $$('[data-variants]').forEach(function (form) {
    var sizes = $$('.size', form);
    var idInput = $('[name="id"]', form);
    sizes.forEach(function (s) {
      s.addEventListener('click', function (e) {
        e.preventDefault();
        if (s.classList.contains('is-out')) return;
        sizes.forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
        s.classList.add('is-on');
        s.setAttribute('aria-checked', 'true');
        if (idInput && s.dataset.variantId) idInput.value = s.dataset.variantId;
        form.dataset.chosen = 'true';
      });
    });
    if ($('.size.is-on', form)) form.dataset.chosen = 'true';
  });

  /* ---------- PDP: Buy now ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-buy-now]');
    if (!b) return;
    e.preventDefault();
    var form = $('#product-form');
    if (!form) return;
    if (form.dataset.requiresSize === 'true' && form.dataset.chosen !== 'true') {
      if (!openSizeSheet(form)) toast('Select a size first');
      return;
    }
    if (!isShopify()) { toast('Buy now works on the live store'); return; }
    var label = b.querySelector('span');
    if (!b.dataset.label) b.dataset.label = label.textContent;
    var old = b.dataset.label;
    b.setAttribute('aria-busy', 'true');
    label.textContent = 'One moment…';
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || 'Unavailable'); label.textContent = old; return; }
        label.textContent = old;
        b.removeAttribute('aria-busy');
        window.location.href = '/checkout';
      })
      .catch(function () { toast('Something went wrong. Try again.'); label.textContent = old; });
  });

  /* ---------- mobile buy bar ---------- */
  var bar = $('[data-buybar]');
  var anchor = $('[data-buybox]');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- wishlist (localStorage-free: cookie fallback for Shopify) ---------- */
  var WISH = 'halfage_wishlist';
  function readWish() {
    try { var m = document.cookie.match(new RegExp(WISH + '=([^;]+)')); return m ? JSON.parse(decodeURIComponent(m[1])) : []; }
    catch (e) { return []; }
  }
  function writeWish(list) {
    document.cookie = WISH + '=' + encodeURIComponent(JSON.stringify(list)) + ';path=/;max-age=15552000';
  }
  function paintWish() {
    var list = readWish();
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.dataset.wish) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = $('[data-wish-label]', b);
      if (label) label.textContent = on ? 'Saved to wishlist' : 'Add to wishlist';
    });
    $$('[data-wish-count]').forEach(function (el) {
      el.textContent = list.length > 9 ? '9+' : list.length;
      el.hidden = list.length === 0;
    });
  }
  window.HALFAGE.wishlist = { read: readWish, paint: paintWish };
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var list = readWish();
    var id = b.dataset.wish;
    var i = list.indexOf(id);
    if (i > -1) { list.splice(i, 1); toast('Removed from wishlist'); }
    else { list.push(id); toast('Saved to wishlist'); }
    writeWish(list);
    paintWish();
  });
  paintWish();

  /* ---------- cart (Shopify AJAX API) ---------- */
  function isShopify() { return typeof window.Shopify !== 'undefined' || !!$('[data-cart-drawer]'); }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        paintCount(cart.item_count);
        renderCart(cart);
      })
      .catch(function () {});
  }

  function renderCart(cart) {
    var body = $('[data-cart-items]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML =
        '<div class="cart-empty">' +
        '<p class="eyebrow eyebrow--muted">Your bag is empty</p>' +
        '<p style="margin-top:14px;color:var(--ash)">Pieces you add will appear here.</p>' +
        '<a class="btn btn--ghost btn--sm" href="/collections/all" style="margin-top:22px"><span>Browse the edit</span></a>' +
        '</div>';
    } else {
      body.innerHTML = cart.items.map(function (it) {
        var vals = (it.options_with_values || [])
          .filter(function (o) { return o.value && o.value !== 'Default Title'; })
          .map(function (o) { return '<span>' + o.value + '</span>'; })
          .join('<i>|</i>');
        var img = it.image
          ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/, '_240x$1$2') +
            '" alt="' + it.product_title + '" width="120" height="160" loading="lazy">'
          : '';
        var was = it.original_line_price > it.final_line_price
          ? '<s>' + money(it.original_line_price) + '</s> ' : '';
        return '<div class="cart-line" data-key="' + it.key + '">' +
          '<a class="cart-line__media" href="' + it.url + '">' + img + '</a>' +
          '<div class="cart-line__body">' +
            '<div class="cart-line__top">' +
              '<a class="cart-line__name" href="' + it.url + '">' + it.product_title + '</a>' +
              '<button class="cart-line__remove" type="button" data-cart-remove="' + it.key + '">Remove</button>' +
            '</div>' +
            '<div class="cart-line__meta">' + vals +
              (vals ? '<i>|</i>' : '') +
              '<button class="cart-line__qty" type="button" data-qty-open="' + it.key + '" data-qty-now="' + it.quantity + '">' +
                'Qty <i>|</i> <b>' + it.quantity + '</b>' +
                '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M2.5 4.5 6 8l3.5-3.5"/></svg>' +
              '</button>' +
            '</div>' +
            '<div class="cart-line__foot">' +
              '<button class="cart-line__wish" type="button" data-cart-wish="' + it.key + '" data-handle="' + it.handle + '">Move to wishlist</button>' +
              '<span class="cart-line__price">' + was + money(it.final_line_price) + '</span>' +
            '</div>' +
          '</div></div>';
      }).join('');
    }
    var sub = $('[data-cart-subtotal]');
    if (sub) sub.textContent = money(cart.total_price);
  }

  /* ---------- quantity picker sheet ---------- */
  var qtyKey = null;
  function openQtySheet(key, current) {
    var sheet = $('#qty-sheet');
    var list = $('[data-qty-list]', sheet);
    if (!sheet || !list) return;
    qtyKey = key;
    var out = '';
    for (var n = 1; n <= 10; n++) {
      out += '<li><button type="button" data-qty-pick="' + n + '"' +
        (n === current ? ' class="is-on" aria-current="true"' : '') + '>' + n + '</button></li>';
    }
    list.innerHTML = out;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    lock();
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-qty-open]');
    if (open) {
      e.preventDefault();
      openQtySheet(open.dataset.qtyOpen, parseInt(open.dataset.qtyNow, 10) || 1);
      return;
    }
    var pick = e.target.closest('[data-qty-pick]');
    if (pick && qtyKey) {
      e.preventDefault();
      changeLine(qtyKey, parseInt(pick.dataset.qtyPick, 10));
      qtyKey = null;
      var sheet = $('#qty-sheet');
      if (sheet) { sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true'); }
      /* the cart drawer stays open behind it, so the scroll lock stays on */
    }
  });

  /* ---------- move a line to the wishlist ---------- */
  document.addEventListener('click', function (e) {
    var w = e.target.closest('[data-cart-wish]');
    if (!w) return;
    e.preventDefault();
    var list = readWish();
    if (w.dataset.handle && list.indexOf(w.dataset.handle) === -1) list.push(w.dataset.handle);
    writeWish(list);
    paintWish();
    var line = w.closest('.cart-line');
    if (line) line.classList.add('is-going');
    changeLine(w.dataset.cartWish, 0);
    toast('Moved to wishlist');
  });

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCartAndCount);
  }
  function paintCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = '(' + n + ')'; });
    $$('[data-cart-badge]').forEach(function (el) {
      el.textContent = n > 9 ? '9+' : n;
      el.hidden = n === 0;
      if (n > 0) {
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      }
    });
  }
  window.HALFAGE.paintCount = paintCount;

  function renderCartAndCount(cart) {
    renderCart(cart);
    paintCount(cart.item_count);
    if (cart.item_count === 0) {
      toast('Your bag is empty');
      setTimeout(function () {
        closeDrawers();
        if (location.pathname !== '/') location.href = '/';
      }, 1100);
    }
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      var line = rm.closest('.cart-line');
      if (line) line.classList.add('is-going');
      changeLine(rm.dataset.cartRemove, 0);
      return;
    }
    var step = e.target.closest('[data-cart-step]');
    if (!step) return;
    var box = step.closest('[data-cart-qty]');
    var input = $('input', box);
    var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.dataset.cartStep, 10));
    input.value = next;
    changeLine(box.dataset.key, next);
  });

  /* add to cart — product form + quick add */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-form]');
    if (!form || !isShopify()) return;
    e.preventDefault();
    var btn = $('[data-add]', form);
    if (form.dataset.requiresSize === 'true' && form.dataset.chosen !== 'true') {
      if (!openSizeSheet(form)) toast('Select a size first');
      return;
    }
    if (btn) { btn.dataset.label = btn.querySelector('span').textContent; btn.querySelector('span').textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || 'Unavailable'); return; }
        toast('Added to bag');
        refreshCartCount();
        openDrawer('cart-drawer');
      })
      .catch(function () { toast('Something went wrong. Try again.'); })
      .finally(function () { if (btn && btn.dataset.label) btn.querySelector('span').textContent = btn.dataset.label; });
  });

  if (isShopify()) refreshCartCount();

  /* ---------- announcement marquee duplication (mobile) ---------- */
  var track = $('[data-marquee]');
  if (track && window.innerWidth < 750) track.innerHTML += track.innerHTML;


  /* ---------- lazy images fade in once decoded ---------- */
  function markLoaded(img) { img.classList.add('is-loaded'); }
  $$('img[loading="lazy"]').forEach(function (img) {
    if (img.complete) markLoaded(img);
    else img.addEventListener('load', function () { markLoaded(img); }, { once: true });
  });
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          var imgs = n.tagName === 'IMG' ? [n] : $$('img[loading="lazy"]', n);
          imgs.forEach(function (i) {
            if (i.complete) markLoaded(i);
            else i.addEventListener('load', function () { markLoaded(i); }, { once: true });
          });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- horizontal rail progress bar ---------- */
  $$('[data-rail]').forEach(function (rail) {
    var bar = $('[data-rail-bar]', rail.parentNode);
    if (!bar) return;
    function paint() {
      var max = rail.scrollWidth - rail.clientWidth;
      var pct = rail.clientWidth / rail.scrollWidth;
      bar.style.width = Math.max(pct * 100, 12) + '%';
      var travel = 100 / Math.max(pct, 0.0001) - 100;
      var pos = max > 0 ? (rail.scrollLeft / max) * travel : 0;
      bar.style.transform = 'translateX(' + pos + '%)';
    }
    rail.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  });

  /* ---------- speed: prefetch a product page on hover or first touch ---------- */
  (function () {
    var done = {};
    function prefetch(url) {
      if (!url || done[url]) return;
      if (navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''))) return;
      done[url] = true;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = url;
      document.head.appendChild(l);
    }
    function fromEvent(e) {
      var a = e.target.closest('a[href]');
      if (!a || a.target === '_blank') return;
      var href = a.getAttribute('href') || '';
      if (href.indexOf('/products/') === -1 && href.indexOf('/collections/') === -1) return;
      if (a.origin && a.origin !== location.origin) return;
      prefetch(a.href);
    }
    document.addEventListener('mouseover', fromEvent, { passive: true });
    document.addEventListener('touchstart', fromEvent, { passive: true });
  })();


  /* ---------- size sheet: opens when you add to bag without a size ---------- */
  function openSizeSheet(form) {
    var sheet = $('#size-sheet');
    var grid = $('[data-size-grid]', sheet);
    if (!sheet || !grid) return false;
    var sizes = $$('.size', form);
    if (!sizes.length) return false;
    grid.innerHTML = sizes.map(function (b) {
      var left = b.dataset.left ? '<em>' + b.dataset.left + ' left</em>' : '';
      return '<button type="button" class="size-cell' + (b.classList.contains('is-out') ? ' is-out' : '') +
        '" data-size-pick="' + b.dataset.size + '"' + (b.classList.contains('is-out') ? ' disabled' : '') + '>' +
        '<span>' + b.dataset.size + '</span>' + left + '</button>';
    }).join('');
    sheet.dataset.formTarget = form.id || 'product-form';
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    lock();
    return true;
  }
  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-size-pick]');
    if (!pick) return;
    e.preventDefault();
    var sheet = $('#size-sheet');
    var form = document.getElementById(sheet.dataset.formTarget || 'product-form');
    if (!form) return;
    var target = $$('.size', form).filter(function (b) { return b.dataset.size === pick.dataset.sizePick; })[0];
    if (target) target.click();
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    unlock();
    setTimeout(function () {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }, 220);
  });

  /* ---------- wishlist page ---------- */
  (function () {
    var grid = $('[data-wishlist-grid]');
    if (!grid) return;
    var empty = $('[data-wishlist-empty]');
    var handles = readWish();
    if (!handles.length) {
      if (empty) empty.hidden = false;
      return;
    }
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var html = items.filter(Boolean).map(function (p) {
        var img = p.featured_image
          ? '<img src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_800x$1$2') +
            '" alt="' + p.title + '" width="800" height="1066" loading="lazy">'
          : '';
        var sizes = (p.variants || []).map(function (v) {
          return '<span' + (v.available ? '' : ' class="out"') + '>' + v.title.split(' / ')[0] + '</span>';
        }).join('');
        return '<article class="pc">' +
          '<a class="pc__media" href="/products/' + p.handle + '"><span class="pc__img pc__img--a">' + img + '</span></a>' +
          '<div class="pc__info"><div class="pc__row">' +
            '<h3 class="pc__name"><a href="/products/' + p.handle + '">' + p.title + '</a></h3>' +
            '<button class="pc__drop" type="button" data-wish="' + p.handle + '" aria-pressed="true" aria-label="Remove from wishlist">Remove</button>' +
          '</div>' +
          '<p class="pc__price">' + money(p.price) + '</p>' +
          '<div class="pc__sizes">' + sizes + '</div></div></article>';
      }).join('');
      grid.innerHTML = html;
      if (!html && empty) empty.hidden = false;
      paintWish();
    });
  })();

  /* ---------- price range: two handles over one track ---------- */
  $$('[data-range]').forEach(function (wrap) {
    var lo = $('[data-range-lo]', wrap);
    var hi = $('[data-range-hi]', wrap);
    var loOut = $('[data-range-lo-out]', wrap);
    var hiOut = $('[data-range-hi-out]', wrap);
    var loField = $('[data-range-lo-field]', wrap);
    var hiField = $('[data-range-hi-field]', wrap);
    if (!lo || !hi) return;
    function fmt(v) { return 'Rs. ' + Number(v).toLocaleString('en-IN'); }
    function paint() {
      var min = +lo.min, max = +lo.max;
      if (+lo.value > +hi.value - 1) lo.value = Math.max(min, +hi.value - 1);
      var a = ((+lo.value - min) / (max - min)) * 100;
      var b = ((+hi.value - min) / (max - min)) * 100;
      wrap.style.setProperty('--from', a + '%');
      wrap.style.setProperty('--to', b + '%');
      if (loOut) loOut.textContent = fmt(lo.value);
      if (hiOut) hiOut.textContent = fmt(hi.value) + (+hi.value === max ? '+' : '');
      if (loField) loField.value = lo.value;
      if (hiField) hiField.value = hi.value;
    }
    lo.addEventListener('input', paint);
    hi.addEventListener('input', paint);
    paint();
  });

  /* ---------- restore button labels on back/forward navigation ---------- */
  function resetPendingButtons() {
    $$('[data-buy-now],[data-add]').forEach(function (b) {
      var span = b.querySelector('span');
      if (span && b.dataset.label) span.textContent = b.dataset.label;
      b.removeAttribute('aria-busy');
    });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) resetPendingButtons(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetPendingButtons();
  });

  /* ---------- page load ---------- */
  document.documentElement.classList.add('is-ready');
})();
